module.exports = __webpack_public_path__ + "img/purchase.4289f8d7.png";